// @flow

/* eslint-disable max-len */
import React from 'react'
import IconBase from 'react-icon-base'

type IconProps = {}

export function OneAxisIcon(props: IconProps) {
  return (
    <IconBase viewBox="0 0 200 113.38" {...props}>
      <g>
        <path d="M150.12,31.52l11.32-10.41C143.95,7.42,122.54,0,100.02,0,73.3,0,48.21,10.41,29.33,29.29,10.41,48.17,0,73.3,0,100.02c0,4.16,3.41,7.57,7.57,7.57s7.57-3.41,7.57-7.57c0-22.67,8.82-43.97,24.86-60.02,16.05-16.05,37.35-24.86,60.02-24.86,18.24,0,35.65,5.75,50.1,16.39Z" />
        <path d="M176.2,35.23l-10.33,11.24c12.3,15.1,19,33.79,19,53.55,0,4.16,3.41,7.57,7.57,7.57s7.57-3.41,7.57-7.57c0-24.03-8.4-46.74-23.8-64.79Z" />
      </g>
      <path d="M178.13,18.88c-1.06-1.02-2.72-1.06-3.82-.08L103.86,83.52c-1.23-.32-2.52-.49-3.85-.49-8.38,0-15.18,6.79-15.18,15.18s6.79,15.18,15.18,15.18,15.18-6.79,15.18-15.18c0-2.03-.4-3.96-1.12-5.73L178.2,22.71c1.02-1.1,.98-2.76-.08-3.82Z" />
    </IconBase>
  )
}

export function TwoAxesIcon(props: IconProps) {
  return (
    <IconBase viewBox="0 0 60 60" {...props}>
      <g
        stroke="currentColor"
        strokeWidth="2"
        transform="translate(10.000000, 10.000000)"
      >
        <path d="M20,39.5833333 L20,0.416666667"></path>
        <path d="M20,39.5833333 L17,28.7833333 L23,28.7833333 L20,39.5833333 Z"></path>
        <path d="M20,0.416666667 L17,11.2166667 L23,11.2166667 L20,0.416666667 Z"></path>
        <path d="M0,20 L41,20"></path>
        <path d="M0,20 L10.8,17 L10.8,23 L0,20 Z"></path>
        <path d="M41,20 L30.2,17 L30.2,23 L41,20 Z"></path>
      </g>
    </IconBase>
  )
}

export function FinancialIcon(props: IconProps) {
  return (
    <IconBase viewBox="0 25 20 30" {...props}>
      <text transform="translate(0.000000, 10.000000)">
        <tspan x="0" y="33">
          $$$
        </tspan>
      </text>
    </IconBase>
  )
}

export function SliderIcon(props: IconProps) {
  return (
    <IconBase viewBox="0 0 200 51.48" {...props}>
      <path d="M116.35,25.74c0-2.8,.34-5.49,.98-8.1H5.98c-3.29,0-5.98,2.69-5.98,5.98v4.2c0,3.29,2.69,5.98,5.98,5.98H117.34c-.61-2.57-.98-5.26-.98-8.06" />
      <path d="M185.43,17.64c.61,2.61,.98,5.3,.98,8.1s-.34,5.49-.98,8.1h8.59c3.29,0,5.98-2.69,5.98-5.98v-4.24c0-3.29-2.69-5.98-5.98-5.98h-8.59Z" />
      <path d="M162.38,34.33c0,1.14-.95,2.08-2.08,2.08h-17.87c-1.14,0-2.08-.95-2.08-2.08v-.87c0-1.14,.95-2.08,2.08-2.08,1.44-.26,3.48-.95,5.68-1.93h0v-3.18h0c-.87-1.1-1.44-2.65-1.51-4.35v-3.1c0-1.78,1.25-3.22,2.91-3.6,.61-.15,1.29-.23,1.97-.23,.72,0,1.4,.08,1.97,.23,1.67,.34,2.91,1.82,2.91,3.6v3.18c-.08,1.82-.72,3.41-1.7,4.5v2.91c2.16,.98,4.2,1.67,5.68,1.97h0c1.14,0,2.08,.95,2.08,2.08v.87h-.04ZM151.36,0c-14.23,0-25.74,11.54-25.74,25.74s11.54,25.74,25.74,25.74,25.74-11.54,25.74-25.74S165.59,0,151.36,0" />
    </IconBase>
  )
}

export function RankingIcon(props: IconProps) {
  return (
    <IconBase viewBox="0 0 188.35 122.28" {...props}>
      <path d="M112.17,0h-35.95c-4.59,0-8.37,3.75-8.37,8.34V113.96c0,4.59,3.75,8.37,8.37,8.37h35.95c4.59,0,8.34-3.75,8.34-8.37V8.34c0-4.59-3.75-8.34-8.34-8.34m0,4.78c1.96,0,3.56,1.59,3.56,3.56V113.96c0,1.96-1.59,3.56-3.56,3.56h-35.95c-1.96,0-3.56-1.59-3.56-3.56V8.34c0-1.96,1.59-3.56,3.56-3.56h35.95Z" />
      <path d="M44.29,0H8.37C3.75,0,0,3.75,0,8.34V113.96c0,4.59,3.75,8.37,8.37,8.37H44.32c4.59,0,8.34-3.75,8.34-8.37V8.34c0-4.59-3.75-8.34-8.37-8.34m0,4.78c1.96,0,3.56,1.59,3.56,3.56V113.96c0,1.96-1.59,3.56-3.56,3.56H8.37c-1.96,0-3.59-1.59-3.59-3.56V8.34c0-1.96,1.59-3.56,3.59-3.56H44.29Z" />
      <path d="M180.01,0h-35.95c-4.59,0-8.34,3.75-8.34,8.34V113.96c0,4.59,3.75,8.34,8.34,8.34h35.95c4.59,0,8.34-3.75,8.34-8.34V8.34c0-4.59-3.75-8.34-8.34-8.34" />
    </IconBase>
  )
}

export function DmpIcon(props: IconProps) {
  return (
    <IconBase viewBox="0 0 200 122.28" {...props}>
      <path d="M144.69,66.84h-4.5v7.87h4.5c1.56,0,2.73-.32,3.52-.97,.79-.65,1.19-1.64,1.19-2.96s-.4-2.31-1.19-2.96c-.79-.65-1.97-.97-3.52-.97Z" />
      <path d="M56.43,66.88h-3.94v17.3h3.94c2.42,0,4.19-.73,5.3-2.18,1.11-1.46,1.67-3.61,1.67-6.47s-.56-5.01-1.67-6.47c-1.11-1.46-2.88-2.18-5.3-2.18Z" />
      <path d="M172.59,41.52c-1.67-.59-2.38-1.47-2.94-3.1-6.48-19.05-19.67-30.3-39.6-33.31-9.94-1.5-19.42,.42-28.28,5.16-1.09,.58-1.74,.53-2.71-.24C86.35-.19,72.13-2.82,57,3.16c-15.35,6.07-24.09,17.82-26.14,34.27-.28,2.24-1.01,3.19-3.14,4.01C12.05,47.48,2.93,58.88,.36,75.49c-.06,.37-.24,.71-.36,1.07v7.81c.89,3.58,1.48,7.26,2.71,10.71,5.65,15.83,20.87,26.91,37.68,27.12,19.71,.23,39.43,.08,59.15,.09,19.33,0,38.65,.13,57.98-.04,17.63-.15,30.66-8.21,38.44-24.02,10.64-21.63-.62-48.7-23.37-56.71Zm-105.16,44.57c-2.38,2.48-5.8,3.72-10.27,3.72h-12.11v-28.54h12.11c4.47,0,7.89,1.24,10.27,3.72,2.38,2.48,3.57,6,3.57,10.55s-1.19,8.07-3.57,10.55Zm50.36,3.72h-6.57v-13.1l.22-8.78h-.09l-7.05,21.88h-6.01l-7.05-21.88h-.09l.22,8.78v13.1h-6.62v-28.54h10.6l4.5,14.53,1.6,6.05h.09l1.64-6.01,4.45-14.57h10.16v28.54Zm37.8-13.88c-.86,1.41-2.12,2.49-3.76,3.24-1.64,.75-3.63,1.12-5.97,1.12h-5.67v9.51h-7.44v-28.54h13.1c2.34,0,4.32,.38,5.97,1.12,1.64,.75,2.9,1.83,3.76,3.24,.86,1.41,1.3,3.13,1.3,5.15s-.43,3.73-1.3,5.15Z" />
    </IconBase>
  )
}

export function VideoSliderIcon(props: IconProps) {
  return (
    <IconBase viewBox="0 0 167.08 122.28" {...props}>
      <g>
        <g>
          <path d="M28.77,122.28c-1.52,0-3.04-.58-4.2-1.74-8.01-8.01-14.21-17.35-18.43-27.78C2.07,82.7,0,72.06,0,61.14c0-10.91,2.07-21.55,6.14-31.62C10.36,19.09,16.56,9.75,24.57,1.74c2.32-2.32,6.08-2.32,8.4,0,2.32,2.32,2.32,6.08,0,8.4-13.6,13.6-21.09,31.71-21.09,51,0,19.29,7.49,37.4,21.09,51,2.32,2.32,2.32,6.08,0,8.4-1.16,1.16-2.68,1.74-4.2,1.74Z" />
          <path d="M49.3,101.76c-1.52,0-3.04-.58-4.2-1.74-21.44-21.44-21.44-56.31,0-77.75,2.32-2.32,6.08-2.32,8.4,0,2.32,2.32,2.32,6.08,0,8.4-16.8,16.8-16.8,44.14,0,60.95,2.32,2.32,2.32,6.08,0,8.4-1.16,1.16-2.68,1.74-4.2,1.74Z" />
        </g>
        <g>
          <path d="M138.31,122.28c-1.52,0-3.04-.58-4.2-1.74-2.32-2.32-2.32-6.08,0-8.4,28.12-28.12,28.12-73.88,0-102-2.32-2.32-2.32-6.08,0-8.4,2.32-2.32,6.08-2.32,8.4,0,32.75,32.75,32.75,86.05,0,118.8-1.16,1.16-2.68,1.74-4.2,1.74Z" />
          <path d="M117.78,101.76c-1.52,0-3.04-.58-4.2-1.74-2.32-2.32-2.32-6.08,0-8.4,8.13-8.13,12.6-18.95,12.6-30.47,0-11.52-4.48-22.35-12.6-30.47-2.32-2.32-2.32-6.08,0-8.4,2.32-2.32,6.08-2.32,8.4,0,10.37,10.37,16.08,24.18,16.08,38.87,0,14.7-5.71,28.5-16.08,38.87-1.16,1.16-2.68,1.74-4.2,1.74Z" />
        </g>
      </g>
      <circle cx="83.54" cy="61.14" r="12.65" />
    </IconBase>
  )
}

export function DefaultIcon() {
  return <IconBase viewBox="0 0 60 60"></IconBase>
}

export const IconByType = {
  'one-axis': OneAxisIcon,
  'two-axes': TwoAxesIcon,
  financial: FinancialIcon,
  ranking: RankingIcon,
  slider: SliderIcon,
  video_slider: VideoSliderIcon,
}

export function iconForType(type: string, isDmpIntegration: boolean = false) {
  if (isDmpIntegration) return DmpIcon

  const iconClass = IconByType[type]
  if (!iconClass) {
    return DefaultIcon
  }
  return iconClass
}



// WEBPACK FOOTER //
// ./src/components/Icons/index.js